module.exports = __webpack_public_path__ + "img/bars.f89e16e8.svg";